import { Component, inject, Input, OnInit, signal, WritableSignal } from '@angular/core';
import { MessageMaintenance } from '../../models/message-maintenance';
import { sign } from 'crypto';
import { MessageMaintenanceService } from '../../services/message-maintenance.service';
import { TuiTable } from '@taiga-ui/addon-table';
import { MessageMaintenanceRowComponent } from '../message-maintenance-row/message-maintenance-row.component';

@Component({
  selector: 'app-message-maintenance-list',
  standalone: true,
  imports: [MessageMaintenanceRowComponent, TuiTable],
  templateUrl: './message-maintenance-list.component.html',
  styleUrl: './message-maintenance-list.component.scss'
})
export class MessageMaintenanceListComponent {
  @Input({ required: true })
  public messageMaintenanceList?: Array<MessageMaintenance>;

  @Input({ required: true })
  public refreshList!: () => void;
}
